/**
 * Rota que o aviso de entrega leva — e onde ele se cala, para não repetir o
 * chamado à ação onde ele já foi atendido.
 */
export const DELIVERY_SETTINGS_PATH = '/settings/delivery';

/** A chave carrega o tenant: dispensar num estabelecimento não silencia outro. */
export function deliverySetupDismissKey(tenantId: string): string {
  return `vaptmenu.panel.delivery-setup-dismissed.${tenantId}`;
}

/**
 * Storage pode estar indisponível (modo privado, política do navegador). O pior
 * caso aceitável é o aviso reaparecer — nunca uma tela branca.
 */
export function readDeliverySetupDismissal(tenantId: string): boolean {
  if (!tenantId) return false;
  try {
    return localStorage.getItem(deliverySetupDismissKey(tenantId)) === '1';
  } catch {
    return false;
  }
}

export function writeDeliverySetupDismissal(tenantId: string): void {
  try {
    localStorage.setItem(deliverySetupDismissKey(tenantId), '1');
  } catch {
    // Dispensa só vale para esta sessão. Melhor que quebrar o painel.
  }
}
